module.exports = __webpack_public_path__ + "static/images/revenue.e28d5fdcea8a5a3d19433424b3161b8d.svg";